<!-- Please don’t change these IDs because those are for automated testing: searchTopInput, calendarImg, addNewchallengeCategoryBtn, challengeCategoryActionDropDown, challengeCategoryEditActionLink, challengeCategoryCopyActionLink, challengeCategoryDeleteActionLink, pagePagination, challengeCategoryNameInput, updateBtn, saveBtn, cancelBtn -->
<div class="mid_container top__padding">
  <div class="top__main pages__filter">
    <div class="container">
      <div class="main_hd_page_top">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6">
            <h1 class="pg__heading">{{translations.CHALLENGE.CHALLENGE_TYPE.MANAGE_CHALLENGE_CATEGORIES | translate}}</h1>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6">
            <div class="main_hd_page_top_right manage-chall-categ-filter-box">
              <app-text-search
                class="global-search"
                [placeholder]="isClearValue ? clearSearchValue() : getTranslation(translations.CHALLENGE.CHALLENGE_TYPE.SEARCH_CHALLENGE_CATEGORY)"
                (textSearchTriggered)="searchByText($event)">
              </app-text-search>
              <app-date-search
                [isRangePickerEnabled]="true"
                class="global-date"
                (dateSearchTriggered)="searchByDate($event)">
              </app-date-search>
            </div>
          </div>
        </div>
      </div>
      <div class="main_hd_page_btm">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 text-right">
            <div class="add__new__btn">
              <a [ngClass]="sAttributes.isShow ? 'filled':''" class="btn_outline" id="addNewchallengeCategoryBtn" href="javascript:void(0);" (click)="toggleForm()">{{translations.GLOBAL.KEYS.ADD_CATEGORIES | translate}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="container admin-manage-challenge-categories-page">


    @if (sAttributes.isShow) {
      <div id="shownew" class="create__new__form__section">
        <button class="div_close" id="createformclose" (click)="toggleForm()"><img
        src="/assets/images/svg_icons/cross.svg" alt="" /></button>
        <div class="create__new__form__in">
          <h1>{{translations.CHALLENGE.ADD_CHALLENGE_CATEGORIES | translate}}</h1>
          <!--------------------- NG-Add Template Code here -------------------------->
          @if (sAttributes.isShow) {
            <form [formGroup]="addEditCategoriesForm"
              (ngSubmit)="sAttributes.itemArray._id ? updateChallengeCategory() : onChallengeCategorySubmit()">
              <div class="edit__form">
                <div class="row input__row">
                  <div class="col-sm-7">
                    <div class="input-field">
                      <label>{{translations.CHALLENGE.CHALLENGE_CATOGORIES_NAME | translate}}</label>
                      <input id="challengeCategoryNameInput" type="text" [placeholder]="getTranslation(translations.CHALLENGE.CHALLENGE_CATOGORIES_NAME)" formControlName="name" />
                      @if (challengeCategoryName.invalid && sAttributes.submitted) {
                        <div
                          class="custom_error">
                          <!-- {{getCustomErrorMessage(challengeCategoryName, getTranslation(translations.CHALLENGE.CHALLENGE_CATOGORIES_NAME), {minLength:2, maxLength: 25 })}} -->
                          {{getCustomErrorMessage(challengeCategoryName, getTranslation(translations.CHALLENGE.CHALLENGE_CATOGORIES_NAME))}}
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="row input__row">
                  <div class="col-sm-7">
                    <div class="input-field">
                      <label>{{translations.GLOBAL.KEYS.STATUS | translate}}</label>
                      <div class="yesno__type__radio">
                        @for (status of globals.statusType; track status; let idx = $index) {
                          <div class="yesno__radio__box">
                            <input type="radio" id="switch_left{{idx}}" class="css-checkbox yesa" name="status"
                              formControlName="status" value="{{status.value}}"
                              [checked]="sAttributes.statusSelected==status.value">
                            <label for="switch_left{{idx}}" class="css-label radGroup2">{{status.name | titlecase}}</label>
                            @if (challengeCategoryStatus.invalid && (challengeCategoryStatus.dirty || sAttributes.submitted )) {
                              <div
                                class="custom_error">
                                @if (challengeCategoryStatus.errors.required) {
                                  <div>First name is required</div>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input__button__box">
                  <button id="{{sAttributes.itemArray && sAttributes.itemArray._id ? 'updateBtn' : 'saveBtn'}}" class="orange-btn_outline" [disabled]="addEditCategoriesForm.pristine">{{(sAttributes.itemArray && sAttributes.itemArray._id ? translations.GLOBAL.KEYS.UPDATE : translations.GLOBAL.KEYS.SAVE) | translate}}</button>
                  <button type="button" id="cancelBtn" (click)="sAttributes.itemArray && sAttributes.itemArray._id ? closeDialogBox() : toggleForm()" class="gray-btn_outline"
                  id="createcancel">{{translations.GLOBAL.KEYS.CANCEL | translate}}</button>
                </div>
              </div>
            </form>
          }
        </div>
      </div>
    }

    <div class="main__row margin__top_25">
      @if (isNoRecordHide && challengeCategoryList.length === 0 && !sAttributes.isShow) {
        <div class="not-found not-found-message">{{translations.GLOBAL.ERROR_MESSAGES.NO_RECORD_FOUND | translate}}</div>
      }
      @for (category of challengeCategoryList; track category; let idx = $index) {
        <div class="list__box">
          @if (sAttributes.isIndex!==idx;) {
            <div class="main__row__list base-list" id="HideBox1">
              <div class="row">
                <div class="col-lg-10 col-md-10 col-sm-10">
                  <div class="simple__info">
                    <h2>{{category.name}}</h2>
                    <div class="status-with-type">
                      <ul>
                        @if (category.status === active) {
                          <li>{{translations.GLOBAL.KEYS.ACTIVE | translate}}</li>
                        }
                        @if (category.status === inactive) {
                          <li>{{translations.GLOBAL.KEYS.INACTIVE | translate}}</li>
                        }
                        @if (isCreatedDateVisible) {
                          <li>
                            <i><img src="assets/images/svg_icons/appointment.svg" alt="" /></i>
                            {{ translations.GLOBAL.KEYS.CREATED_ON | translate}}: &nbsp; {{category.createdDate | date}}
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 custom-justify-content-end">
                  <div class="action__filter">
                    <div class="action dropdown action-dropdown-right" dropdown>
                      <div id="dropdownAction" dropdownToggle class="dropdown-toggle"
                        aria-controls="dropdown-basic"><a id="challengeCategoryActionDropDown" href="javascript:void(0)">{{translations.GLOBAL.KEYS.ACTION | translate}}</a></div>
                        <div class="dropdown-menu" id="dropdown-basic" *dropdownMenu>
                          <a class="dropdown-item" id="challengeCategoryEditActionLink" (click)="setCategoryForEdit(idx)"
                            href="javascript:void(0)">{{translations.GLOBAL.KEYS.EDIT | translate}}<i><img
                          src="/assets/images/svg_icons/edit.svg" alt="" /></i></a>
                          <a class="dropdown-item" id="challengeCategoryCopyActionLink" href="javascript:void(0)"
                            (click)="setCategoryForCopy(category)">{{translations.GLOBAL.KEYS.COPY | translate}} <i><img
                          src="/assets/images/copy-icon.png" alt="" /></i></a>
                          <a class="dropdown-item" id="challengeCategoryDeleteActionLink" href="javascript:void(0)"
                            (click)="openDeletePopup(category._id)">{{translations.GLOBAL.KEYS.DELETE | translate}} <i><img
                          src="/assets/images/svg_icons/gray_delete.svg" alt=""></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (sAttributes.isIndex==idx;) {
              <div class="edit__row__box" id="listeditbox1">
                <button class="div_close" id="close10" (click)="closeDialogBox()"><img
                src="/assets/images/svg_icons/cross.svg" alt=""></button>
                <div class="edit__row__in__box">
                  <h1>{{translations.GLOBAL.KEYS.EDIT | translate}} :- {{category.name}}</h1>
                  <!--------------------- NG-Edit Template Code here -------------------------->
                  @if (sAttributes.isIndex==idx) {
                    <form [formGroup]="addEditCategoriesForm"
                      (ngSubmit)="sAttributes.itemArray._id ? updateChallengeCategory() : onChallengeCategorySubmit()">
                      <div class="edit__form">
                        <div class="row input__row">
                          <div class="col-sm-7">
                            <div class="input-field">
                              <label>{{translations.CHALLENGE.CHALLENGE_CATOGORIES_NAME | translate}}</label>
                              <input id="challengeCategoryNameInput" type="text" [placeholder]="getTranslation(translations.CHALLENGE.CHALLENGE_CATOGORIES_NAME)" formControlName="name" />
                              @if (challengeCategoryName.invalid && sAttributes.submitted) {
                                <div
                                  class="custom_error">
                                  <!-- {{getCustomErrorMessage(challengeCategoryName, getTranslation(translations.CHALLENGE.CHALLENGE_CATOGORIES_NAME), {minLength:2, maxLength: 25 })}} -->
                                  {{getCustomErrorMessage(challengeCategoryName, getTranslation(translations.CHALLENGE.CHALLENGE_CATOGORIES_NAME))}}
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="row input__row">
                          <div class="col-sm-7">
                            <div class="input-field">
                              <label>{{translations.GLOBAL.KEYS.STATUS | translate}}</label>
                              <div class="yesno__type__radio">
                                @for (status of globals.statusType; track status; let idx = $index) {
                                  <div class="yesno__radio__box">
                                    <input type="radio" id="switch_left{{idx}}" class="css-checkbox yesa" name="status"
                                      formControlName="status" value="{{status.value}}"
                                      [checked]="sAttributes.statusSelected==status.value">
                                    <label for="switch_left{{idx}}" class="css-label radGroup2">{{status.name | titlecase}}</label>
                                    @if (challengeCategoryStatus.invalid && (challengeCategoryStatus.dirty || sAttributes.submitted )) {
                                      <div
                                        class="custom_error">
                                        @if (challengeCategoryStatus.errors.required) {
                                          <div>First name is required</div>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="input__button__box">
                          <button id="{{sAttributes.itemArray && sAttributes.itemArray._id ? 'updateBtn' : 'saveBtn'}}" class="orange-btn_outline" [disabled]="addEditCategoriesForm.pristine">{{(sAttributes.itemArray && sAttributes.itemArray._id ? translations.GLOBAL.KEYS.UPDATE : translations.GLOBAL.KEYS.SAVE) | translate}}</button>
                          <button type="button" id="cancelBtn" (click)="sAttributes.itemArray && sAttributes.itemArray._id ? closeDialogBox() : toggleForm()" class="gray-btn_outline"
                          id="createcancel">{{translations.GLOBAL.KEYS.CANCEL | translate}}</button>
                        </div>
                      </div>
                    </form>
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (challengeCategoryList && sAttributes.count > limitForPage) {
          <div class="pagination_nav">
            <pagination id="pagePagination" [totalItems]="sAttributes.count" [rotate]="sAttributes.rotate"
              [maxSize]="sAttributes.maxSize" [itemsPerPage]="sAttributes.limits"
            (pageChanged)="pageChanged($event);" [(ngModel)]="currentPage"></pagination>
          </div>
        }
      </div>

    </div>

  </div>

